module.exports = __webpack_public_path__ + "static/media/Gilroy-Light.c62aded7.otf";